import { NavigableButton } from '@carvana/ds-button';
import Link from '@carvana/ds-link';
import cx from 'classnames';
import Image from '@/common/Image';
import ShiftDigitalEventName from '~/constants/dealership/ShiftDigitalEventName';
import { appAssetsCdnUrl } from '~/constants/environment';
import useServicePhone from '~/hooks/dealership/selectors/useServicePhone';
import styles from './ServiceHero.module.css';

export default function ServiceHero() {
  const servicePhone = useServicePhone();

  return (
    <section className="relative">
      <div className="relative min-h-[320px] overflow-hidden md:min-h-[400px] lg:min-h-[560px]">
        <Image
          src={`${appAssetsCdnUrl}/images/dealership/service-bay.jpg`}
          alt="Service bay"
          width={1440}
          height={560}
          className="absolute inset-0 size-full object-cover"
        />

        <div className={cx('absolute inset-0', styles.gradient)} />

        <svg
          aria-hidden="true"
          className="absolute inset-0 size-full opacity-15"
          xmlns="http://www.w3.org/2000/svg"
        >
          <defs>
            <pattern
              id="hero-grid"
              width="48"
              height="48"
              patternUnits="userSpaceOnUse"
              patternTransform="rotate(8)"
            >
              <path
                d="M 48 0 L 0 0 0 48"
                fill="none"
                stroke="#A5D8FF"
                strokeWidth="0.5"
              />
            </pattern>
          </defs>
          <rect width="100%" height="100%" fill="url(#hero-grid)" />
        </svg>

        <div className="relative z-10 mx-auto max-w-[1272px] px-lg py-4xl md:px-2xl md:py-[96px] md:pb-[120px]">
          <h1 className={cx('max-w-[900px] text-text-inverse', styles.heading)}>
            Service without
            <br />
            <span className="text-[#A5D8FF]">the sales pitch.</span>
          </h1>

          <p
            className={cx(
              'mt-[28px] max-w-[620px] text-[#D2EBFF]',
              styles.subheading
            )}
          >
            Honest recommendations. Realistic timelines. Only the work your
            vehicle actually needs.
          </p>

          <div className="mt-2xl flex flex-wrap items-center gap-lg md:mt-3xl">
            <NavigableButton
              variant="primaryInverted"
              size="md"
              href="/schedule"
              data-adobe-id="schedule-service-hero"
              data-analytics-id="Service Hero - Schedule Service"
              data-sda-event={ShiftDigitalEventName.ScheduleServiceClick}
              data-testid="schedule-service-hero"
            >
              Schedule your service
            </NavigableButton>

            {servicePhone && (
              <Link
                href={`tel:${servicePhone.number}`}
                priority="inverse"
                size="sm"
                preventVisitedColor
                data-adobe-id="click-to-call-service-hero"
                data-analytics-id="Service Hero - Phone"
                data-sda-event={ShiftDigitalEventName.ClickToCall}
                data-sda-event-set-prop={`clickToCallDepartment|${servicePhone.label}`}
                data-testid="service-hero-phone"
              >
                Or call {servicePhone.number}
              </Link>
            )}
          </div>
        </div>
      </div>
    </section>
  );
}
